import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ApprovalFlowStages} from './approval-flow-stages.model';
import * as ApprovalFlowStagesActions from './approval-flow-stages.actions';

export const approvalFlowStagesesFeatureKey = 'approvalFlowStageses';

export interface State extends EntityState<ApprovalFlowStages> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ApprovalFlowStages> = createEntityAdapter<ApprovalFlowStages>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ApprovalFlowStagesActions.addApprovalFlowStages,
    (state, action) => adapter.addOne(action.approvalFlowStages, state)
  ),
  on(ApprovalFlowStagesActions.upsertApprovalFlowStages,
    (state, action) => adapter.upsertOne(action.approvalFlowStages, state)
  ),
  on(ApprovalFlowStagesActions.addApprovalFlowStagess,
    (state, action) => adapter.addMany(action.approvalFlowStagess, state)
  ),
  on(ApprovalFlowStagesActions.upsertApprovalFlowStagess,
    (state, action) => adapter.upsertMany(action.approvalFlowStagess, state)
  ),
  on(ApprovalFlowStagesActions.updateApprovalFlowStages,
    (state, action) => adapter.updateOne(action.approvalFlowStages, state)
  ),
  on(ApprovalFlowStagesActions.updateApprovalFlowStagess,
    (state, action) => adapter.updateMany(action.approvalFlowStagess, state)
  ),
  on(ApprovalFlowStagesActions.deleteApprovalFlowStages,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ApprovalFlowStagesActions.deleteApprovalFlowStagess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ApprovalFlowStagesActions.loadApprovalFlowStagess,
    (state, action) => adapter.setAll(action.approvalFlowStagess, state)
  ),
  on(ApprovalFlowStagesActions.clearApprovalFlowStagess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
